export const T = {
  en_GB: {
    noProductsAssetAllocation:
      "No products added yet. Use the Custom Portfolio Builder to add products, then asset allocation will be available.",
    assetAllocationCalculating:
      "Asset allocation data is being calculated. Please refresh the page in a moment.",
    completeRiskAssetAllocation: "Please complete the risk assessment to see asset allocation.",
    enterInvestmentAmount: "Please enter an investment amount to see the asset allocation.",
    noPortfolioForScore: (score: string) =>
      `No portfolio available for risk score ${score}. Please contact your advisor to see your asset allocation.`,
    assetAllocationNotAvailable:
      "Asset allocation data is not available for this portfolio. This may be because the portfolio products do not have asset class allocations configured.",
    snapshotMissingMessage:
      "Asset allocation data needs to be regenerated. Use the Regenerate button above.",
    errorLoading: "Error loading asset allocation data. Please refresh the page.",
    noData:
      "No asset allocation data available. Products may not have asset class allocations configured.",
    categoryAssetClass: "Asset Class",
    unclassified: "Unclassified",
  },
  nb_NO: {
    noProductsAssetAllocation:
      "Ingen produkter lagt til ennå. Bruk Egendefinert porteføljebygger for å legge til produkter, deretter vil aktivaallokering være tilgjengelig.",
    assetAllocationCalculating: "Aktivaallokeringsdata beregnes. Oppdater siden om et øyeblikk.",
    completeRiskAssetAllocation: "Fullfør risikovurderingen for å se aktivaallokering.",
    enterInvestmentAmount: "Angi et investeringsbeløp for å se aktivaallokeringen.",
    noPortfolioForScore: (score: string) =>
      `Ingen portefølje tilgjengelig for risikoskår ${score}. Kontakt din rådgiver for å se din aktivaallokering.`,
    assetAllocationNotAvailable:
      "Aktivaallokeringsdata er ikke tilgjengelig for denne porteføljen. Dette kan skyldes at porteføljeproduktene ikke har aktivaklasseallokeringer konfigurert.",
    snapshotMissingMessage: "Aktivaallokeringsdata må regenereres. Bruk Regenerer-knappen over.",
    errorLoading: "Feil ved lasting av aktivaallokering. Oppdater siden.",
    noData:
      "Ingen aktivaallokeringsdata tilgjengelig. Produkter har kanskje ikke aktivaklasseallokeringer konfigurert.",
    categoryAssetClass: "Aktivaklasse",
    unclassified: "Uklassifisert",
  },
} as const;
